import { Fields } from "../types/SchemaFactory";
import { TFunction } from "i18next";
import { schemaFactory } from "./SchemaFactory";
import { AddressForm } from "../domain/models/dto/AddressDTO";

export const addressFieldsFactory = (required = true): Fields<AddressForm> => {
    return {
        country: {
            min: 2,
            max: 200,
            required,
            placeholderKey: "userProfile.fields.countryField",
            type: "text",
            initial: "",
        },
        city: {
            min: 2,
            max: 200,
            required,
            placeholderKey: "userProfile.fields.cityField",
            type: "text",
            initial: "",
        },
        address: {
            min: 2,
            max: 200,
            required,
            placeholderKey: "userProfile.fields.addressField",
            type: "text",
            initial: "",
        },
    };
};

export const addressSchemaFactory = (t: TFunction, required = true) => {
    return schemaFactory(t, addressFieldsFactory(required));
};
